import Head from 'next/head'
import Script from 'next/script'
import { BlogHeaderLinks } from '../../../../components/blogs/BlogHeaderLinks'
import { contentDate } from '../../../../utils/article-date-time'
import { blogsMaster } from '../../../../utils/sg-blogs-data'
import { Housing } from '../../../../components/blogs/Housing'
import { getWpNewPostsByCategory, getWpPostsByCategory } from '../../../../lib/service'

// When this page's content last actually changed. Bump it by hand when you
// edit the copy - not for layout/UX changes. Feeds dateModified and
// article:modified_time (see reviewedIso in utils/article-date-time).
const CONTENT_REVIEWED = '2026-09-22'

export async function getStaticProps() {

    const { modifiedDate, month, year } = contentDate(CONTENT_REVIEWED);

    const latestBlogs = blogsMaster['housing'].blogArray

    const wpPosts = await getWpPostsByCategory(100, "housing");
    const wpNewPosts = await getWpNewPostsByCategory(100, "housing"); // retrieve first 100 posts

  return {
      props: {
        modifiedDate,
        month,
        year,
        latestBlogs,
        wpPosts,
        wpNewPosts
      },
      // Next.js will attempt to re-generate the page:
      // - When a request comes in
      // - At most once every 10 seconds
      revalidate: 259200, // In seconds
  }
}

export default function Home(props) {
    const modifiedDate = props.modifiedDate
    const month = props.month
    const year = props.year
    const latestBlogs = props.latestBlogs
    const wpPosts = props.wpPosts
    const wpNewPosts = props.wpNewPosts

  return (
    <>
      <Head>
        <title>{`Everything you need to know about Real Estate in Singapore`}</title>
        <meta charSet="utf-8"/>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge"/>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="description" content="Deep dive into real estate in Singapore with these articles. Learn more about rental and property buy/sell market."/>
        <meta name="keywords" content="House Rental, Insurance Plan, Personal Trainer, Maid Service, Handyman Service, Aircon Service, Savings Plan, Food Catering, Interior Design, Wedding Planner, Event Planner"/>
        <meta name="author" content="StringsSG"/>
        <meta name="google-site-verification" content="JAjj5vAc8Xxrh4idRAchZhYR6rwxWPAk3vxMdx-dwVQ" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:url"   content="https://www.stringssg.com/sg/blogs/housing" />
        <meta property="og:type"   content="article" />
        <meta property="og:title"    content={`Everything you need to know about Real Estate in Singapore`}/>
        <meta property="og:description" content="Deep dive into real estate in Singapore with these articles. Learn more about rental and property buy/sell market." />
        <meta property="article:publisher" content="https://www.facebook.com/StringsSG/" />
        <meta property="article:published_time" content="2025-01-06T07:30:46+00:00" />
        <meta property="article:modified_time" content={`${modifiedDate}`} />
        <meta property="og:image"  content="https://stringssg-assets.s3.ap-southeast-1.amazonaws.com/static/blog/home-living-blogs-main.jpg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content="https://stringssg-assets.s3.ap-southeast-1.amazonaws.com/static/blog/home-living-blogs-main.jpg" />
        <meta name="twitter:site" content="@stringssg"/> 
        <meta name="twitter:url" content="https://www.stringssg.com/sg/blogs/housing"/>
        <meta name="twitter:title" content={`Everything you need to know about Real Estate in Singapore`}/> 
        <meta name="twitter:description" content="Deep dive into real estate in Singapore with these articles. Learn more about rental and property buy/sell market."/>
        <link rel="icon" href="/favicon.ico" />
        <link rel="canonical" href="https://www.stringssg.com/sg/blogs/housing" />
        <script type="application/ld+json"
          dangerouslySetInnerHTML={{ __html:
            `{"@context":"https://schema.org","@graph":[{"@context":"https://schema.org/","@type":"BlogPosting","mainEntityOfPage":{"@type":"WebPage","@id":"https://www.stringssg.com/sg/blogs/housing"},"headline":"Everything you need to know about Real Estate in Singapore","description":"Deep dive into real estate in Singapore with these articles. Learn more about rental and property buy/sell market.","image":["https://stringssg-assets.s3.ap-southeast-1.amazonaws.com/static/blog/home-living-blogs-main.jpg"],"author":{"@type":"Organization","@id":"https://www.stringssg.com/#organization","name":"StringsSG","url":"https://www.stringssg.com/"},"publisher":{"@type":"Organization","@id":"https://www.stringssg.com/#organization","name":"StringsSG","url":"https://www.stringssg.com/","logo":{"@type":"ImageObject","url":"https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/logo.png"}},"datePublished":"2025-01-06T07:30:46+00:00","dateModified":"${modifiedDate}"},{"@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"Blogs","item":"https://www.stringssg.com/sg/blogs"},{"@type":"ListItem","position":2,"name":"housing"}]}]}`
          }}
        />
      </Head>
      <div className='max-w-5xl mx-auto py-10'>
            <Housing latestBlogs={latestBlogs} wpPosts={wpPosts} wpNewPosts={wpNewPosts}/>
      </div>
      <h2 className='bg-gray-800 text-white py-4 p-2 text-center text-2xl'>
          Topics
      </h2>
      <BlogHeaderLinks/>
      <Script 
          id="google-tagmanager-new"
          src="https://www.googletagmanager.com/gtag/js?id=G-QD1HGGHDYJ"
          strategy="lazyOnload"
          onLoad={() => {              
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
          
            gtag('config', 'G-QD1HGGHDYJ');
          }} 
      />
      <Script id="facebook-tracking" strategy="lazyOnload">
          {`!function(f,b,e,v,n,t,s)
					  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
					  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
					  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
					  n.queue=[];t=b.createElement(e);t.async=!0;
					  t.src=v;s=b.getElementsByTagName(e)[0];
					  s.parentNode.insertBefore(t,s)}(window, document,'script',
					  'https://connect.facebook.net/en_US/fbevents.js');
					  fbq('init', '128634041116395');
					  fbq('track', 'PageView');`}
        </Script>
    </>
  )
}
